export default "__VITE_ASSET__CO8YqNlv__"